import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  fabGF: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
  },
}));

export { useStyles };
